module.exports = __webpack_public_path__ + "static/media/mg-go-drive.7d89fa1c.png";